import React from "react";
import { Button, Form, InputGroup } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { fetchPage } from "../../../../redux/reducers/TemplateField";
type Props = {
  numPages: number;
};
export const GoToPage: React.SFC<Props> = ({ numPages }) => {
  const [page, setPage] = React.useState(1);
  const dispatch = useDispatch();

  return (
    <>
      <InputGroup>
        <Form.Control
          style={{ width: "75px" }}
          type="number"
          placeholder="Page #"
          value={page}
          onChange={(e) =>
            setPage(
              Math.min(numPages, Math.max(1, parseInt(e.target.value, 10)))
            )
          }
        />
        <Button
          variant="secondary"
          className="ml-2"
          onClick={() => {
            dispatch(fetchPage({ pageNumber: page - 1 }));
          }}
        >
          Go
        </Button>
      </InputGroup>
    </>
  );
};
export default GoToPage;
